import type { PartnerConfigInput } from "../../config/schema";
import Logo from "./Logo";
import meta from "./meta.json";

const eastshipper = {
  partnerId: "eastshipper",
  apiPartnerId: 40,
  ffidPrefix: "SH",
  appName: "EAST Shipper",

  // Shared with server.js, which serves these as crawler-visible head tags.
  meta,

  logo: {
    alt: "EAST Shipper",
    Component: Logo,
  },

  theme: {
    light: {},
    dark: {},
  },

  chat: { provider: "intercom", appId: "g8pf25uo" },

  features: {
    shopify: true,
    tools: true,
    support: true,
    delivery: true,
    mailbox: true,
    addressParsing: true,
    usdtDeposits: false,
    telegramLink: false,
    smsNumbers: false,
  },

  payments: {
    creditCard: true,
    paypal: true,
    overpay: true,
    stripe: true,
  },

  currency: {
    code: "USD",
    symbol: "$",
  },

  signup: { mode: "open", partnerToken: "KOPEBPAP" },

  // No marketing landing — anonymous "/" keeps redirecting to /signin.
  publicRoot: "signin",

  branches: {
    sbNames: ["USA", "Germany"],
  },

  mailboxes: {
    countries: ["USA", "Germany"],
  },

  api: {
    homeCardsPrefix: "east_",
  },
} satisfies PartnerConfigInput;

export default eastshipper;
